/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'index.scss';
import { ConfigProvider, message, DatePicker } from 'antd';
import esES from 'antd/es/locale/es_ES';
import App from 'views/App';
import * as serviceWorker from 'serviceWorker';
import Moment from 'moment';

const validateMessages = {
  required: 'El campo es requerido',
  types: {
    email: 'Ingrese un correo electrónico válido',
    integer: 'Ingrese un número enteró',
    url: 'Ingrese una URL válida',
  },
};

DatePicker.defaultProps = {
  locale: esES,
  placeholder: '',
  format: 'DD/MM/YYYY',
};

message.config({
  top: 100,
  duration: 2.5,
  maxCount: 1,
});

Moment.locale('es', {
  months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
  weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_'),
  week: { dow: 1 },
});

const { error } = console;
// eslint-disable-next-line no-console
console.error = (...args) => {
  if (/defaultProps|deprecated|(will be removed in next major version)/.test(args[0])) return;
  error(...args);
};

document.title = process.env.REACT_APP_TITLE || 'Ingresos';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <ConfigProvider form={{ validateMessages }} locale={esES}>
    <App />
  </ConfigProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// if (process.env.NODE_ENV === 'production') {
//   serviceWorker.register();
//   serviceWorker.register({
//     onUpdate: (registration) => {
//       const waitingServiceWorker = registration.waiting;
//       console.log('[onUpdate]');
//       if (waitingServiceWorker) {
//         console.log('[if waitingServiceWorker]');
//         waitingServiceWorker.addEventListener('statechange', (event) => {
//           console.log('[addEventListener]');
//           if (event.target.state === 'activated') {
//             console.log('[if event.target.state activated]', event.target.state);
//             // eslint-disable-next-line no-alert
//             if (window.confirm('There is a new version of the app ready. Please reload.')) {
//               window.location.reload();
//             }
//           }
//         });
//         waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
//       }
//     },
//   });
// }
